var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 506.548,
    height: 460,
    viewBox: "0 0 506.548 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "banner-img",
    transform: "translate(-2426.313 -804.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819",
    transform: "translate(2426.477 804.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M3749.289,2377.986s33.015-30.376,107.27-28.677,46.357-32.93,100.647-20.346c17.425,4.039,47.022,34.688,76.905,29.751s51.4,3.982,59.059,19.272Z",
    transform: "translate(-3611.341 -1919.58)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M3978.642,2322.311c1.343-.39,12.427-31.314-3.368-42.485S3978.642,2322.311,3978.642,2322.311Z",
    transform: "translate(-3772.381 -1884.471)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M3937.768,2376.844s-11.146-23.506-21.538-25.121S3937.768,2376.844,3937.768,2376.844Z",
    transform: "translate(-3732.16 -1938.231)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M4434.231,2183.61s-18.387-61.572.309-70.5S4434.231,2183.61,4434.231,2183.61Z",
    transform: "translate(-4107.381 -1762.904)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M4483.433,2265.731c-.559-.892,5.427-37.462,20.163-39.563S4483.433,2265.731,4483.433,2265.731Z",
    transform: "translate(-4149.334 -1846.213)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3813",
    "data-name": "Group 3813",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781",
    transform: "translate(84.253 310.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M3633.872,2129.963l-1.3.424c-5.132-11.311-13.022-19.693-20.7-26.726a62.651,62.651,0,0,0-45.093-15.614,78.361,78.361,0,0,0-17.844,3.08l-.637-1.5c40.027-15.7,63.055,2.74,74.936,19.526A80.453,80.453,0,0,1,3633.872,2129.963Z",
    transform: "translate(-3548.295 -2052.305)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M3679.407,2020.551l-45.534,23.379a84.6,84.6,0,0,0-12.6-18.727,104.53,104.53,0,0,0-7.636-8.021c-27.109-24.858-65.341-13.594-65.341-13.594l33.453-33.71c20.174-6.807,37.865-3.225,52.451,4.5C3662.767,1989.515,3679.407,2020.551,3679.407,2020.551Z",
    transform: "translate(-3548.295 -1966.273)",
    fill: "#a8d29f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780",
    transform: "translate(7.556 2.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M3656.034,2047.069c-.029-.132-3.571-11.835-14.507-23.674a57.093,57.093,0,0,0-23.265-15.235c-11.313-3.977-24.569-4.889-39.4-2.712l-2.285.335,27.187-26.857.124-.056c.35-.157,8.717-3.851,21.71-3.315a66.007,66.007,0,0,1,22.639,5.111,88.1,88.1,0,0,1,26.559,17.756c.654.607,16.843,16.636,20.965,27.541h0Zm.4-1.7,37.238-20.411c-1.647-4.356-5.606-10.128-11.448-16.693-4.439-4.989-8.425-8.7-8.464-8.737a86.639,86.639,0,0,0-26.051-17.441,64.535,64.535,0,0,0-22.091-5.014,55.661,55.661,0,0,0-17.93,2.073,11.79,11.79,0,0,0-4.946,2.918l-18.841,18.613a1.472,1.472,0,0,0,1.169,2.512c12.522-1.118,23.846.074,33.738,3.56a58.593,58.593,0,0,1,23.878,15.673,64.664,64.664,0,0,1,11.4,17.486A47.374,47.374,0,0,1,3656.436,2045.369Z",
    transform: "translate(-3576.578 -1975.502)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M3798.226,2026.5c2.922,6.9.646,12.784-6.256,15.706s-15.812,1.778-18.735-5.123-.848-12.647,6.053-15.569S3795.3,2019.6,3798.226,2026.5Z",
    transform: "translate(-3712.201 -2005.63)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M3876.848,1326.95s-2.274,16.077.324,26.3h-38.719s18.2-66.642,55.481-104.783c10.7-10.952,20.544-26.546,30.045-43.687,23.588-42.561,45.053-94.664,72.243-108.879,0,0-53.711,78.922-64.114,124.43S3885.3,1264.539,3876.848,1326.95Z",
    transform: "translate(-3676.686 -1017.95)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M3919.3,1519.013a134.988,134.988,0,0,1,4.684-15.551c-9.5,17.141-19.345,32.735-30.045,43.687a154.811,154.811,0,0,0-15.236,18.408,127.548,127.548,0,0,0-7.583-29.43c-5.858-14.628-15.9-29.475-32.662-30.767,0,0,40.585,31.1,19.992,94.854a333.3,333.3,0,0,0-19.992,51.718h25.906c-2.6-10.223-.324-26.3-.324-26.3C3872.488,1563.222,3908.893,1564.521,3919.3,1519.013Z",
    transform: "translate(-3676.686 -1316.633)",
    fill: "#ffb973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M3951.3,1655.173s-.055.1-.155.261c-1.063,1.778-7.183,11.805-6.634,5.638.6-6.749-6.992-32.184-6.992-32.184l6.2-3.15A127.559,127.559,0,0,1,3951.3,1655.173Z",
    transform: "translate(-3749.287 -1406.243)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M4223.152,1139.012s0,.007.008.007l-1.126,1.715a98.2,98.2,0,0,0-21.34-7.831,78.826,78.826,0,0,0-48.363,3.621,69.76,69.76,0,0,0-10.846,5.49c-11.064,6.955-22.7,15.525-31.588,28.338l-1.516-.82-42.042-32.295-8.913-6.844a155.345,155.345,0,0,1,16.257-16.739c11.809-10.616,29.3-23.537,49.981-30.083a83.586,83.586,0,0,1,38.472-3.3,82.571,82.571,0,0,1,27.316,9.567l33.707,49.174A.011.011,0,0,1,4223.152,1139.012Z",
    transform: "translate(-3837.161 -1005.809)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784",
    transform: "translate(146.837 316.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M3935.017,2139.383l1.17.407c4.841-10.13,12.123-17.562,19.188-23.78a56.63,56.63,0,0,1,41.033-13.3,70.9,70.9,0,0,1,16.07,3.106l.6-1.348c-35.89-14.911-57.034,1.338-68.073,16.293A72.734,72.734,0,0,0,3935.017,2139.383Z",
    transform: "translate(-3894.289 -2069.749)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M3782.563,2038.39l40.729,21.95a76.473,76.473,0,0,1,11.724-16.7,94.734,94.734,0,0,1,7.046-7.11c24.947-21.975,59.294-11.106,59.294-11.106l-29.623-31.068c-18.108-6.516-34.162-3.6-47.482,3.122C3798.161,2010.643,3782.563,2038.39,3782.563,2038.39Z",
    transform: "translate(-3782.563 -1990.706)",
    fill: "#a8d29f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783",
    transform: "translate(3.975 2.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M3797.443,2043.4h0c3.921-9.78,18.842-23.974,19.443-24.51a79.621,79.621,0,0,1,24.322-15.568,59.649,59.649,0,0,1,20.551-4.21c11.751-.25,19.246,3.239,19.559,3.387l.112.053,24.084,24.761-2.059-.344c-13.362-2.235-25.358-1.649-35.654,1.74a51.6,51.6,0,0,0-21.3,13.348c-10.1,10.5-13.508,21.014-13.537,21.132Zm37.408,13.352a58.459,58.459,0,0,1,10.62-15.6,52.957,52.957,0,0,1,21.862-13.733c9-2.971,19.257-3.844,30.553-2.608a1.33,1.33,0,0,0,1.1-2.249L3882.3,2005.4a10.647,10.647,0,0,0-4.416-2.727,50.31,50.31,0,0,0-16.167-2.2,58.33,58.33,0,0,0-20.054,4.133A78.314,78.314,0,0,0,3817.8,2019.9c-.037.033-3.706,3.315-7.807,7.743-5.4,5.828-9.08,10.973-10.647,14.879l33.284,19.119A42.876,42.876,0,0,1,3834.851,2056.747Z",
    transform: "translate(-3797.443 -1999.095)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M3933.964,2043.619c-2.765,6.184-.813,11.54,5.371,14.305s14.258,1.892,17.022-4.292,1-11.414-5.189-14.179S3936.73,2037.435,3933.964,2043.619Z",
    transform: "translate(-3892.618 -2025.309)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M4176.78,1136.524a69.775,69.775,0,0,0-10.845,5.49c-11.065,6.955-22.7,15.525-31.587,28.338l-1.516-.82-42.042-32.295a202.523,202.523,0,0,1,7.344-23.584c11.81-10.616,29.3-23.537,49.98-30.083a83.589,83.589,0,0,1,38.473-3.3c.456.294.7.46.7.46S4166.138,1106.423,4176.78,1136.524Z",
    transform: "translate(-3861.61 -1005.809)",
    fill: "#719e67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M3807.084,964.814l-63.838,7.3-1.719-.077a82.615,82.615,0,0,0-2.814-16.5,127.822,127.822,0,0,0-9.667-24.063,73.236,73.236,0,0,0-10.142-14.822,78.386,78.386,0,0,0-35.916-23.485,98.343,98.343,0,0,0-22.322-4.284l-.085-2.049h0L3714.8,862.05a80.618,80.618,0,0,1,59.621,28.511c12.4,14.05,20.313,30.955,25.236,45.09A163.73,163.73,0,0,1,3807.084,964.814Z",
    transform: "translate(-3546.332 -846.572)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M3959.653,950.671c-.92,11.856-6.958,21.53-19.425,25.06-13.631,3.856-28.677.8-41.524-5.17a127.761,127.761,0,0,0-9.667-24.063,73.235,73.235,0,0,0-10.141-14.822c28.224-6.6,23.249-49.13,23.249-49.13a83.3,83.3,0,0,1,32.272,23.036C3946.818,919.632,3954.729,936.537,3959.653,950.671Z",
    transform: "translate(-3706.324 -861.593)",
    fill: "#719e67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M3834.911,1087.157s-1.153-12.093-23.759-7.206A24,24,0,0,0,3834.911,1087.157Z",
    transform: "translate(-3656.677 -1005.41)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M4098.2,1384l.014.007-33.708-49.174c-23.377-12.956-46.033-12.523-65.788-6.27-38.69,12.247-66.239,46.82-66.239,46.82l50.957,39.14v0l1.515.817c8.888-12.811,20.522-21.382,31.59-28.336a78.649,78.649,0,0,1,59.207-9.112,98.4,98.4,0,0,1,21.342,7.829l1.125-1.715Z",
    transform: "translate(-3745.594 -1185.352)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M3622.3,1177.268l-.015.007,33.708-49.174c23.377-12.956,46.033-12.524,65.789-6.27,38.69,12.247,66.239,46.82,66.239,46.82l-50.957,39.14v0l-1.515.818c-8.889-12.811-20.523-21.382-31.59-28.336a78.649,78.649,0,0,0-59.208-9.112,98.39,98.39,0,0,0-21.341,7.829l-1.126-1.714Z",
    transform: "translate(-3518.267 -1033.847)",
    fill: "#719e67"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785",
    transform: "translate(0 326.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M3465.9,2059.222a116.767,116.767,0,1,0,233.534,0Z",
    transform: "translate(-3403.659 -2050.219)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M3610.853,2059.222H3465.9a116.847,116.847,0,0,0,135.643,115.245,47.242,47.242,0,0,0-4.85-2.323c-46.377-19.505-59.52-58.174-48.545-81.318,10.963-23.119,75.093-28.025,75.093-28.025Z",
    transform: "translate(-3403.659 -2050.219)",
    fill: "#e58638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M4012.519,2154.547h0c42.949-15.167,73.276-52.132,73.276-95.324h-25.23C4060.565,2102.419,4047.1,2135.578,4012.519,2154.547Z",
    transform: "translate(-3804.25 -2050.219)",
    fill: "#ffb973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M3562.162,2479.03h180.68a16.87,16.87,0,0,0-3.218-10.186,9.864,9.864,0,0,0-7.772-4.222h-158.7C3567.084,2464.622,3562.162,2471.076,3562.162,2479.03Z",
    transform: "translate(-3474.205 -2347.317)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 240.032,
    height: 3.582,
    transform: "translate(299.616 12.584) rotate(180)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M3232.917,2025.531c0,.017.027.034.078.043C3232.944,2025.527,3232.917,2025.509,3232.917,2025.531Z",
    transform: "translate(-3232.917 -2025.522)",
    fill: "#ffb973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M3652.5,2473.087a9.752,9.752,0,0,1,3.972-8.465h-83.321c-6.07,0-10.992,6.454-10.992,14.408h94.313S3652.622,2479.03,3652.5,2473.087Z",
    transform: "translate(-3474.205 -2347.317)",
    fill: "#e58638"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788",
    transform: "translate(174.337 5.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M3925.083,936.64l-1.525-.8c5.664-14.527,6.276-28.966,5.863-42.03a78.642,78.642,0,0,0-25.508-54.2,98.374,98.374,0,0,0-18.413-13.33l.793-1.892c49.2,22.2,52.824,59.053,48.159,84.444A100.989,100.989,0,0,1,3925.083,936.64Z",
    transform: "translate(-3885.501 -824.385)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M3988.192,957.048l-60.927-20.411c3.511-9.231,5.083-19.639,5.777-27.739a131.15,131.15,0,0,0,.511-13.892c-1.436-46.149-45.075-70.621-45.075-70.621l59.615.5c23.8,12.156,36.1,31.191,41.943,51.07C4001.485,914.887,3988.192,957.048,3988.192,957.048Z",
    transform: "translate(-3887.683 -824.384)",
    fill: "#a8d29f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787",
    transform: "translate(11.525 2.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M3961.213,942.379c.092-.142,7.5-13.585,8.549-33.788a71.674,71.674,0,0,0-6.71-34.259c-6.347-13.651-17.149-26.361-32.107-37.775l-2.3-1.758,47.964.877.159.062c.449.177,11.1,4.456,22.013,16.6a82.845,82.845,0,0,1,15.257,24.82c4.654,11.668,7.121,24.934,7.333,39.429.028,1.119-.179,29.719-6.362,42.982h0Zm1.88-1.129,50.987,15.559c2.468-5.3,4.183-13.917,4.959-24.922.59-8.362.43-15.2.428-15.265-.208-14.244-2.622-27.26-7.171-38.7a81.009,81.009,0,0,0-14.863-24.244,69.894,69.894,0,0,0-17.583-14.291,14.8,14.8,0,0,0-6.958-1.885l-33.241-.608a1.847,1.847,0,0,0-1.233,3.252c11.983,10.27,20.84,21.488,26.382,33.431a73.553,73.553,0,0,1,6.855,35.194,81.183,81.183,0,0,1-5.712,25.575C3964.167,938.775,3963.951,939.788,3963.093,941.249Z",
    transform: "translate(-3928.641 -834.797)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M4125.036,975.6c-8.677-3.638-15.658-.464-19.3,8.212s3.147,17.686,11.822,21.323,15.958.527,19.6-8.149S4133.711,979.241,4125.036,975.6Z",
    transform: "translate(-4046.169 -934.118)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791",
    transform: "translate(74.803 85.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M3620.35,1328.17l-1.637.532c-6.442-14.2-16.347-24.722-25.984-33.55a78.652,78.652,0,0,0-56.607-19.6,98.406,98.406,0,0,0-22.4,3.868l-.8-1.889c50.249-19.71,79.157,3.44,94.07,24.512A100.986,100.986,0,0,1,3620.35,1328.17Z",
    transform: "translate(-3512.922 -1230.683)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M3677.514,1190.822l-57.161,29.348c-4.154-8.959-10.505-17.354-15.817-23.508a131.226,131.226,0,0,0-9.586-10.069c-34.031-31.2-82.024-17.065-82.024-17.065l41.994-42.318c25.325-8.545,47.534-4.049,65.844,5.652C3656.624,1151.861,3677.514,1190.822,3677.514,1190.822Z",
    transform: "translate(-3512.925 -1122.684)",
    fill: "#a8d29f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    transform: "translate(9.486 3.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M3648.172,1224.11c-.037-.166-4.482-14.856-18.21-29.717a71.669,71.669,0,0,0-29.206-19.125c-14.2-4.992-30.843-6.138-49.459-3.405l-2.869.421,34.128-33.714.157-.07c.439-.2,10.943-4.834,27.252-4.161a82.866,82.866,0,0,1,28.42,6.416c11.6,4.819,22.817,12.319,33.339,22.291.82.761,21.144,20.884,26.318,34.573h0Zm.5-2.134,46.746-25.624c-2.068-5.468-7.039-12.714-14.373-20.956-5.571-6.262-10.575-10.921-10.625-10.967-10.34-9.8-21.34-17.163-32.7-21.894a81.011,81.011,0,0,0-27.731-6.3,69.88,69.88,0,0,0-22.509,2.6,14.789,14.789,0,0,0-6.208,3.663l-23.652,23.365a1.848,1.848,0,0,0,1.467,3.154c15.719-1.4,29.935.093,42.352,4.468a73.552,73.552,0,0,1,29.975,19.675,81.2,81.2,0,0,1,14.314,21.95C3647.656,1219.479,3648.231,1220.342,3648.677,1221.976Z",
    transform: "translate(-3548.429 -1134.271)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M3826.671,1198.294c-3.668-8.663-15.11-9.929-23.773-6.26s-11.267,10.882-7.6,19.545,14.855,10.1,23.518,6.431S3830.339,1206.957,3826.671,1198.294Z",
    transform: "translate(-3718.68 -1172.09)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794",
    transform: "translate(214.311 31.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M4269.971,1109.412l1.719.1c2.628-15.369,9.541-28.06,16.624-39.045a78.646,78.646,0,0,1,49.782-33.32,98.356,98.356,0,0,1,22.649-1.942l.294-2.03c-53.6-6.318-75.694,23.408-84.775,47.574A101.015,101.015,0,0,0,4269.971,1109.412Z",
    transform: "translate(-4207.235 -1002.674)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M4035.136,1014.214l62.736,13.887c1.745-9.72,5.76-19.451,9.335-26.752a131.348,131.348,0,0,1,6.718-12.171c25-38.817,75.012-37.314,75.012-37.314l-51.356-30.281c-26.664-1.841-47.006,8.142-62.256,22.17C4045.458,971.228,4035.136,1014.214,4035.136,1014.214Z",
    transform: "translate(-4035.136 -921.365)",
    fill: "#a8d29f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793",
    transform: "translate(4.878 2.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M4053.4,1019.327h0c1.532-14.553,16.086-39.173,16.687-40.118,7.649-12.315,16.6-22.415,26.594-30.019a82.857,82.857,0,0,1,25.863-13.415c15.606-4.788,26.941-2.969,27.417-2.889l.168.028,41.564,23.954-2.88.32c-18.7,2.08-34.506,7.409-46.978,15.841a71.657,71.657,0,0,0-23.4,25.909c-9.51,17.857-10.083,33.2-10.076,33.365Zm55.041,3.659a81.192,81.192,0,0,1,8.278-24.863,73.539,73.539,0,0,1,24-26.635c10.9-7.382,24.271-12.436,39.833-15.066a1.848,1.848,0,0,0,.619-3.423l-28.805-16.6a14.8,14.8,0,0,0-6.935-1.969A69.879,69.879,0,0,0,4123,937.622a81,81,0,0,0-25.227,13.124c-9.79,7.458-18.562,17.372-26.079,29.473-.036.057-3.694,5.833-7.5,13.3-5,9.833-7.971,18.1-8.585,23.917l51.716,12.926C4107.345,1028.672,4107.682,1027.692,4108.437,1022.986Z",
    transform: "translate(-4053.396 -932.481)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M4221.019,1017.417c-9.31-1.351-20.057,2.776-21.408,12.087s3.288,15.727,12.6,17.078,19.767-2.876,21.118-12.187S4230.33,1018.767,4221.019,1017.417Z",
    transform: "translate(-4155.503 -991.573)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796",
    transform: "translate(194.987 67.167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 43.272,
    cy: 43.272,
    r: 43.272,
    transform: "translate(3.669 62.087) rotate(-45)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 43.272,
    cy: 43.272,
    r: 43.272,
    transform: "translate(0 61.196) rotate(-45)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795",
    transform: "translate(21.634 22.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M4083.3,1217.715a39.726,39.726,0,0,1-9.379-1.129,39.209,39.209,0,1,1,9.379,1.129Zm-.139-76.528a37.128,37.128,0,1,0,8.819,1.062A37.334,37.334,0,0,0,4083.157,1141.186Z",
    transform: "translate(-4043.784 -1138.834)",
    fill: "#ffa412"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3799",
    "data-name": "Group 3799",
    transform: "translate(55.053 140.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 168.765,
    height: 70.775,
    transform: "matrix(0.962, -0.272, 0.272, 0.962, 0, 45.855)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797",
    transform: "translate(10.958 8.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M3480.015,1402.078l15.333,54.309,143.459-40.5-15.333-54.31Zm153.8,3.974a8.684,8.684,0,0,1-6,10.723L3504.3,1451.646a7.777,7.777,0,0,1-9.6-5.372l-9.735-34.481a8.564,8.564,0,0,1,5.916-10.572l123.052-34.741a8.382,8.382,0,0,1,10.342,5.788Z",
    transform: "translate(-3480.015 -1361.575)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M3746.874,1485.776a17.569,17.569,0,1,0-12.134,21.681A17.569,17.569,0,0,0,3746.874,1485.776Z",
    transform: "translate(-3639.355 -1434.32)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M3751.37,1328.272l19.23,68.112-126.981,35.851c5.875-3.683,59.675-21.391,70.749-45.942,13.44-29.794,2.9-46.12,3.187-48.474Z",
    transform: "translate(-3588.954 -1328.272)",
    fill: "#82b378",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802",
    transform: "translate(237.548 159.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 168.765,
    height: 70.775,
    transform: "translate(0 0.738) rotate(-0.25)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800",
    transform: "translate(9.611 6.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M4158.1,1424.506l.247,56.432,149.065-.652-.247-56.432Zm147.135,44.972a8.683,8.683,0,0,1-8.65,8.726l-128.341.561a7.777,7.777,0,0,1-7.812-7.744l-.157-35.829a8.565,8.565,0,0,1,8.529-8.6l127.861-.559a8.381,8.381,0,0,1,8.416,8.343Z",
    transform: "translate(-4158.095 -1423.854)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M4390.274,1464.924a17.569,17.569,0,1,0,17.646,17.492A17.569,17.569,0,0,0,4390.274,1464.924Z",
    transform: "translate(-4305.819 -1447.519)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M4392.736,1399.773l.309,70.775-131.945.577c6.646-1.978,63.223-4.648,80.46-25.342,20.919-25.114,15.132-43.663,16.038-45.855Z",
    transform: "translate(-4223.972 -1399.773)",
    fill: "#82b378",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804",
    transform: "translate(219.107 187.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M4146.637,1530.109a43.272,43.272,0,1,0-17,58.785A43.271,43.271,0,0,0,4146.637,1530.109Z",
    transform: "translate(-4062.156 -1507.719)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M4134.262,1536.931a43.272,43.272,0,1,0-17,58.785A43.271,43.271,0,0,0,4134.262,1536.931Z",
    transform: "translate(-4053.087 -1512.718)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803",
    transform: "translate(4.083 6.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M4107.871,1609.464a39.583,39.583,0,0,1-11.012-1.572,39.183,39.183,0,1,1,11.012,1.572Zm-.109-76.533a37.182,37.182,0,1,0,10.355,1.477A37.241,37.241,0,0,0,4107.762,1532.93Z",
    transform: "translate(-4068.371 -1530.577)",
    fill: "#ffa412"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806",
    transform: "translate(153.425 140.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M3882.711,1361.185a32.514,32.514,0,1,0-29.59,35.2A32.515,32.515,0,0,0,3882.711,1361.185Z",
    transform: "translate(-3814.976 -1331.473)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M3872.133,1362.1a32.514,32.514,0,1,0-29.59,35.2A32.515,32.515,0,0,0,3872.133,1362.1Z",
    transform: "translate(-3807.225 -1332.143)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805",
    transform: "translate(2.924 3.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M3847.771,1403.888a29.664,29.664,0,0,1-29.491-27.071h0a29.624,29.624,0,1,1,32.067,26.96Q3849.051,1403.888,3847.771,1403.888Zm-27.73-27.223a27.856,27.856,0,1,0,25.351-30.154,27.887,27.887,0,0,0-25.351,30.154Z",
    transform: "translate(-3818.168 -1344.637)",
    fill: "#ffa412"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808",
    transform: "translate(178.825 74.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M3938.63,1092.827a16.993,16.993,0,1,0-5.83,23.313A16.993,16.993,0,0,0,3938.63,1092.827Z",
    transform: "translate(-3905.792 -1084.574)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M3933.871,1095.682a16.993,16.993,0,1,0-5.829,23.314A16.992,16.992,0,0,0,3933.871,1095.682Z",
    transform: "translate(-3902.305 -1086.666)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3807",
    "data-name": "Group 3807",
    transform: "translate(1.62 2.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M3923.873,1124.708a15.49,15.49,0,0,1-13.3-7.514h0a15.49,15.49,0,1,1,13.3,7.514Zm-12.511-7.989a14.559,14.559,0,1,0,5-19.974,14.576,14.576,0,0,0-5,19.974Z",
    transform: "translate(-3908.368 -1093.75)",
    fill: "#ffa412"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810",
    transform: "translate(250.217 22.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M4196.169,889.741a16.993,16.993,0,1,0,12.189,20.711A16.992,16.992,0,0,0,4196.169,889.741Z",
    transform: "translate(-4173.476 -888.822)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M4190.8,888.349a16.993,16.993,0,1,0,12.189,20.711A16.993,16.993,0,0,0,4190.8,888.349Z",
    transform: "translate(-4169.539 -887.802)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3809",
    "data-name": "Group 3809",
    transform: "translate(1.458 1.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M4190.483,925.148a15.484,15.484,0,0,1-14.985-19.366h0a15.482,15.482,0,1,1,14.985,19.366Zm-.023-30.048a14.578,14.578,0,0,0-14.067,10.914h0a14.558,14.558,0,1,0,17.744-10.443A14.668,14.668,0,0,0,4190.46,895.1Z",
    transform: "translate(-4174.997 -894.175)",
    fill: "#ffa412"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812",
    transform: "translate(303.118 146.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M4373.219,1371.545a13.382,13.382,0,1,1,18.359,4.591A13.382,13.382,0,0,1,4373.219,1371.545Z",
    transform: "translate(-4370.309 -1351.277)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M4369.471,1373.793a13.382,13.382,0,1,1,18.36,4.59A13.382,13.382,0,0,1,4369.471,1373.793Z",
    transform: "translate(-4367.562 -1352.924)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3811",
    "data-name": "Group 3811",
    transform: "translate(1.275 1.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M4384.547,1382.883a12.2,12.2,0,0,1-10.477-5.917h0a12.2,12.2,0,1,1,10.477,5.917Zm-9.852-6.291a11.465,11.465,0,1,0,3.933-15.73,11.478,11.478,0,0,0-3.933,15.73Z",
    transform: "translate(-4372.336 -1358.504)",
    fill: "#ffa412"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M3721.959,1363.552s-9.331-6.571-16.322-5.283-14.559,10.285-14.559,10.285,13.959,1.545,19.135-.414S3721.959,1363.552,3721.959,1363.552Z",
    transform: "translate(-3568.681 -1210.105)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M4382.439,1310.327s15.915-8.653,21.987-5.786,9.292,9.675,9.292,9.675a106.867,106.867,0,0,1-13.064.46C4394.95,1314.4,4391.087,1309.289,4382.439,1310.327Z",
    transform: "translate(-4075.346 -1170.426)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M4477.482,1067.752s10.636-5.264,15.407-4.037a44.142,44.142,0,0,1,9.593,4.037s-5.925,3.568-11.691,3.323S4477.482,1067.752,4477.482,1067.752Z",
    transform: "translate(-4144.999 -994.227)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M4206.915,823.433s-5.491-6.808-3.573-11.775a45.6,45.6,0,0,1,3.573-7.544s5.026,5.7,4.814,9.66S4206.915,823.433,4206.915,823.433Z",
    transform: "translate(-3943.797 -804.114)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M4301.616,884.4s-1.284-8.569,2.69-11.023,10.354-2.453,10.354-2.453-.981,7.237-3.68,8.832S4302.8,882.22,4301.616,884.4Z",
    transform: "translate(-4015.97 -853.073)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M4062.742,1775.907s5.377,7.605,5.622,10.3-7.586,9.568-7.586,9.568-2.533-6.624-1.429-9.935S4062.742,1775.907,4062.742,1775.907Z",
    transform: "translate(-3838.365 -1516.295)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M4008.274,1613.285s-7.992,2.7-9.1,7.114a23.27,23.27,0,0,0-.736,7.575S4010.01,1622.362,4008.274,1613.285Z",
    transform: "translate(-3793.892 -1397.117)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M4043.13,1613.285s2.467,2.821,2.522,4.784a6.547,6.547,0,0,1-1.261,3.672S4041.481,1619.4,4043.13,1613.285Z",
    transform: "translate(-3826.313 -1397.117)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814",
    transform: "translate(251.919 184.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M4554.635,1503.84c.024-.647.523-7.612,11.135-7.976,0,0-5.218.622-6.119,2.916,0,0,3.552-2.835,6.445-1.923s4.592,5.98,4.61,7.647-1.591,7.042-3.426,7.5a5.6,5.6,0,0,1-2.224,0,25.188,25.188,0,0,1,1.425,2.544c4.234,8.691-.132,17.185-3.717,16.247-2.3-.6-2.948,3.321-2.948,3.321l-22.334-18.081S4545.684,1499.063,4554.635,1503.84Z",
    transform: "translate(-4440.888 -1495.864)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M4182.94,2026.874l-.515,3.278c-.533,1.211-1.338,4.082-1.724,5.363h-4.791C4179.417,2031.222,4182.94,2026.874,4182.94,2026.874Z",
    transform: "translate(-4175.91 -1885.016)",
    fill: "#8ab8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M4572.588,2079.781l4.744,1.766s20.6-28.578,23.142-53.721a38.214,38.214,0,0,0-.678-12.855s.2-1.15.554-3.183c.163-.949.364-2.092.592-3.4.67-3.839,1.592-9.09,2.646-15.07,2.425-13.761,5.565-31.352,8.005-44.284l-1.277-.411-13.832-4.461-2.858-9.078-10.3-2.711s-2.3,4.5-4.357,25.759c-.379,2.788-.723,5.864-.983,9.2a181.982,181.982,0,0,0,.98,37.239q.708,5.542,1.809,11.429a51.054,51.054,0,0,1,.4,11.286C4580.132,2047.838,4572.588,2079.781,4572.588,2079.781Z",
    transform: "translate(-4466.616 -1815.76)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M4592.8,1967.33l22.363,44.458c.163-.949.364-2.092.592-3.4.67-3.839,1.592-9.09,2.645-15.07,2.425-13.761,5.566-31.352,8.005-44.284l-1.277-.411-13.831-4.461-2.859-9.078-10.3-2.711s-2.3,4.5-4.357,25.759C4593.4,1960.92,4593.057,1963.995,4592.8,1967.33Z",
    transform: "translate(-4481.427 -1815.76)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M4629.622,1923.891l.518-4.44c8.672,2.3,31.846-6.437,31.846-6.437s8.4,7.386,7.3,25.09c-.539,8.641-1.521,45.36-2.549,56.226-.371,3.938-.7,6.741-.83,7.86a.026.026,0,0,0,0,.011,1.551,1.551,0,0,0,.251.962,50.938,50.938,0,0,1,3.792,7.974c10.083,26.867-1.553,59.955-1.553,59.955l-3.02-1.217s-6.621-36.823-12-53.09a32.267,32.267,0,0,0-2.591-6.223c-2.339-3.775-4.51-9.944-6.48-17.281-3.724-13.871-6.722-31.917-8.717-45.845C4635.31,1947.449,4629.622,1923.891,4629.622,1923.891Z",
    transform: "translate(-4508.414 -1801.574)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M4418.5,1723.557a15.025,15.025,0,0,0-2.657-5.313,2.694,2.694,0,0,0-.5-.61,12.384,12.384,0,0,0-3.411-2.908c-.861-.359-1.794.072-2.764,1.113v.036a16.482,16.482,0,0,0-2.477,3.662c-.036.036-.072.072-.072.108-.18.323-.359.682-.575,1.077a.884.884,0,0,0-.143.252q-.593,1.239-1.185,2.585c-4.416,9.621-9.119,24.2-13.033,28.541-1.687,1.867-9.405,5.529-15.545,8.257-4.416,1.939-8.005,3.375-8.005,3.375s-4.425-.863-5.437,0-5.812,5.74-4.783,7.34,5.954-1.325,6.979-1.6,3.888-1.395,3.888-1.395.287,0,.79-.036c1.579-.108,5.421-.323,9.765-.79,6.534-.646,14.288-1.8,17.375-3.7,4.7-2.872,12.421-11.668,17.448-20.463a5.734,5.734,0,0,0,.358-.646c2.622-4.667,4.453-9.3,4.6-13A18.553,18.553,0,0,0,4418.5,1723.557Z",
    transform: "translate(-4309.184 -1656.166)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M4567.6,1663.612a27,27,0,0,0,9.987,2.339c14.912.817,18.3-12.254,18.913-20.93a12.508,12.508,0,0,0-5.116-.647c-1.057.058-2.162.167-3.072.279-1.823-.953-5.1-5.581-6.994-13.323l-.643.3-10.759,5.058s1.143,3.5,1.987,6.851c.658,2.623,1.13,5.155.735,5.864-.848.345-1.354.561-1.354.561a.025.025,0,0,1-.005.012A73.857,73.857,0,0,0,4567.6,1663.612Z",
    transform: "translate(-4462.962 -1595.141)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M4576.27,1637.513s1.144,3.5,1.986,6.851c6.289-1.755,8.2-8.365,8.773-11.91Z",
    transform: "translate(-4469.314 -1595.965)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M4545.067,1590.185s15.046-3.482,12.733-12.819-1.929-16.074-11.633-14.245-10.681,5.852-10.667,9.156S4541.094,1590.85,4545.067,1590.185Z",
    transform: "translate(-4439.437 -1544.933)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M4530.5,1562.308c1.618-3.384,3.522-3.2,4.712-2.6a10.794,10.794,0,0,1,14-1.2,18.372,18.372,0,0,0,8.454,9.082s-2.312,2.367-9.011,2.315a11.031,11.031,0,0,1-5.976-2.25,36,36,0,0,0,7.846,5.851c-8.386-1.6-14.01-11.314-14.586-12.344a12.1,12.1,0,0,0-2.183,5.168c-.156,2.563.727,7.539-.742,7.728C4533.015,1574.056,4528.071,1567.383,4530.5,1562.308Z",
    transform: "translate(-4435.278 -1540.265)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M4585.544,1724.446a13.419,13.419,0,0,1-3.315-7.459c-.825-7.818-.512-15.145-.581-19.6h0c-.821-.608-1.615-1.17-2.355-1.7a21.068,21.068,0,0,1-2.866-2.378,4.34,4.34,0,0,1-1.375-2.707,14.392,14.392,0,0,1,.059-2.27c.035-.36.081-.72.135-1.081a30.8,30.8,0,0,1,2.162-7.215c-4-1.619-11.116-.655-11.116-.655s.008.4.012,1.042c.023,2.6,0,9.272-.833,10.534-1.042,1.573-20.1,8.463-21.107,6.328-.992-2.1,1.723-11.932,1.823-12.3a.028.028,0,0,0,0-.012c-6.359,2.5-8.646,4.594-8.663,4.608h0s-3.623,6.319-4.165,7.946a8.711,8.711,0,0,1,4.82,1.413,19.034,19.034,0,0,0,.6,9.466c.113.3.236.589.372.887,3.776,8.134,10.767,41.824,10.767,41.824-1,6.057,45.523-1.189,45.643-6.7C4597.2,1738.555,4589.746,1729.159,4585.544,1724.446Z",
    transform: "translate(-4437.868 -1630.142)",
    fill: "#e3251e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M4630.887,1778.775c9.175-.1,16.944-9.624,21.693-17.239a13.221,13.221,0,0,1-1.906-5.562c-.825-7.818-.511-15.145-.581-19.6h0c-.821-.608-1.615-1.17-2.355-1.7a21,21,0,0,1-2.865-2.378C4637.359,1744.991,4618.446,1778.906,4630.887,1778.775Z",
    transform: "translate(-4506.313 -1669.13)",
    fill: "#b70700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M4709.049,2477.026h23.893a13.123,13.123,0,0,0-.675-6.4c-1.2-2.651-3.069-3.856-2.621-7.063a8.607,8.607,0,0,1-7.447,2.849c-.423.686-2.732,4.358-4.146,5.374C4716.492,2472.9,4709.529,2472.5,4709.049,2477.026Z",
    transform: "translate(-4566.622 -2205.041)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M4517.016,2479.964h23.893s.893-3.811-.676-6.4c-1.388-2.295-.856-3.6.172-5.5a9.286,9.286,0,0,1-4.024.758,8.424,8.424,0,0,1-3.554-1.25c-1.028,1.172-5.431,6.163-6.807,7.152C4524.459,2475.842,4517.5,2475.442,4517.016,2479.964Z",
    transform: "translate(-4425.891 -2207.979)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M4281.57,1928.392l-5.678-13.851a3.84,3.84,0,0,0-4.563-2.237,23.682,23.682,0,0,0-7.407-8.427,17.633,17.633,0,0,0-10-3.29,14.151,14.151,0,0,0-5.335,1.056c-8.074,3.308-11.691,13.509-8.729,23.525l-.442.18s-1.379-.1-3.694-.1c-7.312,0-23.934.972-35.6,9.071a3.219,3.219,0,0,0-.762,1.972,3.086,3.086,0,0,0,.247,1.307s18.72-12.122,36.033.335q1.594,1.143,3.1,2.124l1.553,3.79a12.381,12.381,0,0,0,16.107,6.742l15.856-6.5,3.3-1.354A11.028,11.028,0,0,0,4281.57,1928.392Zm-30.741-11.227-6.459,2.65a3.785,3.785,0,0,0-2.226,4.419l-.692.283c-2.627-9.126.578-18.329,7.787-21.284a12.169,12.169,0,0,1,3.105-.82,15.049,15.049,0,0,1,9.888,2.4,21.743,21.743,0,0,1,7.489,8.121l-.953.39a3.789,3.789,0,0,0-4.684-1.586l-6.462,2.65a3.2,3.2,0,0,0-4.159-1.745l-.894.368A3.2,3.2,0,0,0,4250.829,1917.165Z",
    transform: "translate(-4193.098 -1792.466)",
    fill: "#eb0900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M4238.743,2021.813q-1.507-.983-3.1-2.123c-17.313-12.456-36.033-.335-36.033-.335a3.086,3.086,0,0,1-.247-1.307c2.62-1.725,12.441-7.466,24.611-5.5C4238.235,2014.843,4240.815,2016.826,4238.743,2021.813Z",
    transform: "translate(-4193.098 -1874.218)",
    fill: "#a80600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M4420.9,1942.74l-3.3,1.354c4.953-2.7-1.18-14.13-4.769-21.674s-9.015-4.1-9.015-4.1a4.316,4.316,0,0,0-3.909-2.392,3.014,3.014,0,0,0-2-2.926l.9-.368a3.2,3.2,0,0,1,4.159,1.745l6.461-2.65a3.789,3.789,0,0,1,4.685,1.586l.953-.39a21.747,21.747,0,0,0-7.489-8.121,15.048,15.048,0,0,0-9.887-2.4,7.034,7.034,0,0,0,1.578-1.826,17.628,17.628,0,0,1,10,3.29,23.66,23.66,0,0,1,7.407,8.427,3.84,3.84,0,0,1,4.563,2.237l5.678,13.851A11.028,11.028,0,0,1,4420.9,1942.74Z",
    transform: "translate(-4338.439 -1792.466)",
    fill: "#b10700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M4521.761,1694.043c-.071-10.411-5.241-11.847-5.241-11.847-.107-.036-.215-.072-.359-.107-.9-.144-1.831.466-2.8,1.651a32.618,32.618,0,0,0-3.841,6.785c-2.046,4.631-4.2,10.626-6.211,16.587-1.112,3.266-2.189,6.533-3.267,9.549-.61,1.831-1.221,3.554-1.8,5.134a49.49,49.49,0,0,1-3.015,7,17.429,17.429,0,0,1-4.416,3.985,160.892,160.892,0,0,1-14.217,8.831c-2.01,1.149-3.913,2.19-5.493,3.052-1.328.287-8.078,1.723-11.237,1.006-3.554-.826-9.514,3.446-9.514,3.446s-.646,1.365,1.652,2.3c2.3.969,5.528,4.344,10.7,2.3a80.083,80.083,0,0,1,9.513-2.908c.754-.144,1.185-.251,1.185-.251,2.011-.395,4.416-.934,7.037-1.508h.036c4.487-1.077,9.514-2.369,13.75-3.806a37.781,37.781,0,0,0,7.323-3.267,4.351,4.351,0,0,0,.5-.359c4.2-3.051,9.189-12.026,13.067-21.647.539-1.329,1.042-2.657,1.544-3.949a98.1,98.1,0,0,0,4.092-13.642,38.464,38.464,0,0,0,.97-6.5A15.774,15.774,0,0,0,4521.761,1694.043Z",
    transform: "translate(-4376.976 -1632.325)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M4672.1,1690.59c6.911-1.905,12.242,3.491,12.242,3.491-.086-10.394-5.26-11.817-5.26-11.817C4677,1681.4,4674.584,1685.006,4672.1,1690.59Z",
    transform: "translate(-4539.542 -1632.374)",
    fill: "#b70700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818",
    transform: "translate(59.61 170.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M3672.961,1571.951s8.714,9.435,18.509,5.618a61.058,61.058,0,0,0,1.112-9.163c0-.462.009-.91.017-1.336.052-4.23.195-6.6.195-6.6l-.01,0c-.446-.186-14.972-6.15-14.96-5.654C3678.073,1566.251,3672.961,1571.951,3672.961,1571.951Z",
    transform: "translate(-3615.015 -1525.099)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M3696.6,1564.807c1.4,2.6,6.206,7.676,13.315,9.532.053-4.23.195-6.6.195-6.6l-.01,0C3709.7,1567.626,3696.182,1564.042,3696.6,1564.807Z",
    transform: "translate(-3632.331 -1532.368)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M3700.847,1500.56s-16.335,3.84-18.571-6.37-5.849-16.59,4.487-19.474,13.221.567,14.8,3.793S3705.039,1499.3,3700.847,1500.56Z",
    transform: "translate(-3620.026 -1465.631)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M3660,1475.013c-.223.143-3.738,1.223-10.395-12.038a11.549,11.549,0,0,1,.679-10.564c2.436-3.979,11.073-7.108,18.249-8.469s8.9,2.676,10.588,6.734c1.774,4.26,6.9,7.767,6.9,7.767-6.188,3.457-13.641-1.487-16.223-.674s-3.494,4.882-3.688,6.187-.491,2.388-3.738,1.224-1.469,4.6-.948,5.7C3661.419,1470.883,3661.86,1473.82,3660,1475.013Z",
    transform: "translate(-3597.188 -1443.673)",
    fill: "#a9453d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815",
    transform: "translate(0 125.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M3476.78,2447.044h-9.892c-2.073,0-4.378-2.076-4.955-5.877s-4.839-5.877-5.762-8.989,3.8-7.492,3.8-7.492l.789-1.015.823-1.059,7.836,1.843s.193,1.866.313,4.242a54.133,54.133,0,0,1,.031,5.439c-.231,4.15,1.163,8.617,4.849,9.424S3476.78,2447.044,3476.78,2447.044Z",
    transform: "translate(-3456.052 -2286.508)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M3714.543,2474.907h-26.22a2.345,2.345,0,0,1-.557-.161c-1.75-.877-1.2-7.579-.992-9.649.04-.384.069-.609.069-.609s9.22-7.374,10.489-1.727c.04.176.086.349.135.519v0c1.6,5.283,8.756,7.682,12.888,8.352C3713.513,2472.147,3714.332,2473.988,3714.543,2474.907Z",
    transform: "translate(-3624.955 -2314.371)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M3664.3,1941.443s-1.4,17.47-3.045,38.47c-2.237,28.526-4.927,63.567-5.193,70.2-.46,11.527-2.306,29.965-2.306,29.965s-4.377,4.381-13.138,2.534c0,0-7.806-26.321-10.037-54.17-.034-.456-.069-.916-.1-1.376-2.075-28.35-5.3-88.048-5.3-88.048Z",
    transform: "translate(-3579.992 -1932.108)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M3664.3,1941.443s-1.4,17.47-3.045,38.47l-30.674,48.534c-.034-.456-.069-.916-.1-1.376-2.075-28.35-5.3-88.048-5.3-88.048Z",
    transform: "translate(-3579.992 -1932.108)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M3544.72,1924.549s-25.239,63.269-41.834,93-21.781,38.03-21.781,38.03-9.508-3.8-10.372-6.4c0,0,6.346-57.4,17.46-71.394,6.28-7.906,13.657-31.635,14-39.932s2.247-24.72,2.247-24.72Z",
    transform: "translate(-3466.811 -1913.14)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816",
    transform: "translate(11.874 47.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M3508.978,1908.733l-.267,4.07a8.767,8.767,0,0,1-4.835,10.936s-3.219,1.3-3.349-1.207.281-1.563.019-5.092,1.126-6.863,3.46-7.986l1.915-2.21Z",
    transform: "translate(-3500.501 -1831.265)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M3511.708,1703.267c2.793.9,3.241.694,3.241.694s13.6-24.755,14.974-27.021,28.869-27.759,28.869-27.759l-7.065-26.345s-31.268,40.49-34.645,46.3c-5.579,9.6-8.849,31.9-8.849,31.9A8.178,8.178,0,0,0,3511.708,1703.267Z",
    transform: "translate(-3506.167 -1622.836)",
    fill: "#1e3d70"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M3643.331,1643.849c-.1,5.41-.412,11.492-.835,17.669q-.04.549-.079,1.1c-.271,3.827-.565,7.663-.9,11.4-.135,1.5-.28,2.982-.429,4.438l-.023.2c-.012.545-.079,1.136-.139,1.676-1.378,14.01-2.823,25.078-3.091,25.248a1.569,1.569,0,0,1-1.076.274c-3.674-.461-14.635.372-23.61-1.58-7.573-1.6-14.094-4.626-21-8.709-.917-.542-3.008-1.979-2.837-3.051.167-1.179.476-2.884.868-5.026a272,272,0,0,0,4.514-35.272q.234-4.191.678-8.268a125.489,125.489,0,0,1,3.659-19.745c3.078-11.08,9.28-19.384,14.953-22.7.742-.415,3.049,1.943,6.711,4.293a16.174,16.174,0,0,0,10.408,2.466l3.048,3.371c3.692,4.291,7.622,10,8.7,18.125q.12.9.207,1.915A119.093,119.093,0,0,1,3643.331,1643.849Z",
    transform: "translate(-3553.7 -1559.298)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M3722.62,1709.68c-.1,5.41-.412,11.492-.836,17.669q-.039.549-.078,1.1c-20.986-13.136-24.218-37.173-24.218-37.173,10.324.453,18.525,2.826,24.847,6.22A119.233,119.233,0,0,1,3722.62,1709.68Z",
    transform: "translate(-3632.989 -1625.129)",
    fill: "#1e3d70"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3817",
    "data-name": "Group 3817",
    transform: "translate(62.63 52.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M4023.679,1648.783l3.82-1.96a10.46,10.46,0,0,1,11.677-6.965s3.749.759,2.18,3.1-1.3,1.241-3.442,4.581-5.622,5.516-8.463,5.129l-3.2.845Z",
    transform: "translate(-3934.668 -1639.743)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M3783.241,1652.266c-1.082-2.926-2.765-2.736-2.765-2.736s-31.2,7.776-34,8.109-33.6-12.026-33.6-12.026-12.123-5.441-17.8-.473c-4.935,4.317-5.159,9.785-4,14.378a13.731,13.731,0,0,0,11.6,10.229c12.566,1.6,37.636,4.613,42.892,3.882,11.7-1.628,38.194-16.925,38.194-16.925A9.829,9.829,0,0,0,3783.241,1652.266Z",
    transform: "translate(-3690.49 -1642.166)",
    fill: "#2a4e96"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    d: "M1.608,0H504.94a1.608,1.608,0,0,1,1.608,1.608v0a1.608,1.608,0,0,1-1.608,1.608H1.607A1.607,1.607,0,0,1,0,1.608v0A1.608,1.608,0,0,1,1.608,0Z",
    transform: "translate(-0.164 456.784)",
    fill: "#2e3552"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M4169.886,1593.751a3.421,3.421,0,0,0-1.24-6.729l-26.527,4.888a3.421,3.421,0,1,0,1.24,6.729l7.591-1.4a8.008,8.008,0,0,1,8.08,3.034l-14.865,2.739a3.421,3.421,0,1,0,1.24,6.729l14.865-2.739a7.76,7.76,0,0,1-6.406,6.05l-7.59,1.4a3.455,3.455,0,0,0-1.232,6.282l22.276,14.439a3.418,3.418,0,0,0,3.721-5.735l-15.1-9.834a14.914,14.914,0,0,0,11.408-13.906l4.581-.844a3.421,3.421,0,1,0-1.239-6.729l-4.583.844a12.863,12.863,0,0,0-2.793-4.008Z",
    transform: "translate(-1470.698 -573.714)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M3905.679,1400.015a2.456,2.456,0,1,0-.258-4.905l-19.338,1.016a2.456,2.456,0,1,0,.257,4.905l5.534-.291a5.75,5.75,0,0,1,5.471,2.91l-10.837.569a2.456,2.456,0,1,0,.258,4.905l10.836-.569a5.57,5.57,0,0,1-5.122,3.712l-5.534.291a2.48,2.48,0,0,0-1.46,4.357L3900,1429.263a2.454,2.454,0,1,0,3.182-3.737l-9.833-8.4a10.708,10.708,0,0,0,9.413-8.84l3.339-.176a2.456,2.456,0,1,0-.258-4.905l-3.341.176a9.227,9.227,0,0,0-1.616-3.112Z",
    transform: "translate(-1283.409 -433.11)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M4221.188,915.618a1.42,1.42,0,0,0,.933-2.683l-10.58-3.677a1.42,1.42,0,0,0-.933,2.683l3.027,1.052a3.323,3.323,0,0,1,2.295,2.753L4210,913.685a1.421,1.421,0,0,0-.934,2.683l5.929,2.061a3.222,3.222,0,0,1-3.554.87l-3.027-1.052a1.434,1.434,0,0,0-1.732,2.015l5.079,9.782a1.419,1.419,0,1,0,2.52-1.307l-3.432-6.647a6.193,6.193,0,0,0,6.971-2.68l1.827.635a1.42,1.42,0,0,0,.933-2.683l-1.828-.635a5.325,5.325,0,0,0-.186-2.02Z",
    transform: "translate(-1519.951 -76.996)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M3945.535,1110.058a1.42,1.42,0,1,0-.908-2.692l-10.612,3.58a1.42,1.42,0,1,0,.908,2.692l3.036-1.024a3.325,3.325,0,0,1,3.5.768l-5.947,2.006a1.42,1.42,0,1,0,.908,2.692l5.947-2.006a3.222,3.222,0,0,1-2.274,2.866l-3.037,1.025a1.434,1.434,0,0,0-.134,2.654l10.01,4.615a1.419,1.419,0,1,0,1.19-2.577l-6.787-3.147a6.193,6.193,0,0,0,3.865-6.391l1.833-.618a1.42,1.42,0,1,0-.908-2.692l-1.833.619a5.349,5.349,0,0,0-1.385-1.482Z",
    transform: "translate(-1319.533 -222.184)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M4403.453,1379.706a.947.947,0,1,0-.533-1.817l-7.164,2.1a.947.947,0,1,0,.533,1.817l2.05-.6a2.216,2.216,0,0,1,2.311.6l-4.015,1.178a.947.947,0,0,0,.534,1.817l4.014-1.178a2.147,2.147,0,0,1-1.591,1.848l-2.05.6a.956.956,0,0,0-.16,1.765l6.544,3.34a.946.946,0,0,0,.861-1.685l-4.437-2.277a4.128,4.128,0,0,0,2.744-4.154l1.237-.363a.947.947,0,0,0-.533-1.817l-1.238.363a3.543,3.543,0,0,0-.884-1.024Z",
    transform: "translate(-1658.131 -420.464)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M4149.838,1205.827a3.372,3.372,0,0,0-.354-6.734l-26.549,1.394a3.372,3.372,0,0,0,.354,6.734l7.6-.4a7.892,7.892,0,0,1,7.51,3.995l-14.876.781a3.372,3.372,0,0,0,.353,6.734l14.877-.781a7.65,7.65,0,0,1-7.033,5.1l-7.6.4a3.405,3.405,0,0,0-2,5.982l19.93,16.952a3.369,3.369,0,0,0,4.368-5.13l-13.5-11.536a14.7,14.7,0,0,0,12.922-12.136l4.585-.241a3.372,3.372,0,0,0-.354-6.734l-4.586.241a12.671,12.671,0,0,0-2.219-4.273Z",
    transform: "translate(-1456.351 -289.458)",
    fill: "#ffa412"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg);
export default __webpack_public_path__ + "static/media/banner-img.eb4c9289c52b48a474e25f5751a7e1a7.svg";
export { ForwardRef as ReactComponent };